import { Link } from 'react-router-dom';
import type { AnimeItem } from '@/mocks/anime';

interface AnimeCardProps {
  anime: AnimeItem;
}

export default function AnimeCard({ anime }: AnimeCardProps) {
  return (
    <Link
      to={`/category/${anime.category}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-100">
        <img
          src={anime.cover}
          alt={anime.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
            {anime.score}
          </span>
          {anime.isHot && (
            <span className="px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
              热门
            </span>
          )}
          {anime.isNew && (
            <span className="px-2 py-0.5 rounded-md bg-secondary-800 text-secondary-100 text-xs font-medium">
              新番
            </span>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-xs text-background-200 line-clamp-2 leading-relaxed">{anime.description}</p>
        </div>
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
          {anime.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{anime.episode}</span>
          <span className="text-xs text-foreground-400">|</span>
          <span className="text-xs text-foreground-500">{anime.year}</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-1.5">
          {anime.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-1.5 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}